import PropTypes from "prop-types";
import GrFilterDrawer from "src/design-system/components/GrFilterDrawer";
import GrSelect from "src/design-system/components/GrSelect";

// Values the API filters on (points_type); the labels are what members see.
export const TYPE_OPTIONS = [
  { value: "workout", label: "Workout" },
  { value: "food", label: "Food" },
  { value: "mindset", label: "Mindset" },
  { value: "community", label: "Community" },
];

// Filters drawer of the Coins History page: the coin type, Clear All + Filter at the bottom.
export default function CoinsFilter({
  open,
  onClose,
  filterData,
  searchSubmitFilter,
  handleClearFilter,
  setFilterData,
}) {
  const handleChangeOthers = (event, name) => {
    setFilterData((values) => ({ ...values, [name]: event }));
  };

  return (
    <GrFilterDrawer
      open={open}
      onClose={onClose}
      title="Filters"
      onClear={handleClearFilter}
      clearLabel="Clear All"
      onApply={searchSubmitFilter}
      applyLabel="Filter"
    >
      <GrSelect
        id="coins-filter-type"
        label="Type"
        name="type"
        value={filterData?.type}
        onChange={(e) => handleChangeOthers(e.target.value, "type")}
        options={TYPE_OPTIONS}
      />
    </GrFilterDrawer>
  );
}

CoinsFilter.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  filterData: PropTypes.shape({ type: PropTypes.string }),
  setFilterData: PropTypes.func.isRequired,
  searchSubmitFilter: PropTypes.func.isRequired,
  handleClearFilter: PropTypes.func.isRequired,
};
